<template lang="html">
	<entity-page id="page__manipulator" v-bind:loading="progress">
		<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>

		<div class="row">
			<z-select
				label="Тип расчёта" v-model="price.type" :required="true" name="type" id="type" class="col-6"
				v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('type')"
			>
				<option v-bind:value="null" selected disabled>Выбрать...</option>
				<option v-bind:value="1">По весу</option>
				<option v-bind:value="2">По объёму</option>
			</z-select>

			<z-select
				v-bind:label="'Тип расчёта цены по времени'" class="col-6"
				v-model="price.is_min" :required="true" name="is_min" id="is_min"
				v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('is_min')"
			>
				<option v-bind:value="null" selected disabled>Выбрать...</option>
				<option v-bind:value="0">За 1 час</option>
				<option v-bind:value="1">За всё время</option>
			</z-select>
		</div>

		<div class="row">
			<z-input
				:label="`Минимальный ${(parseInt(price.type) == 1 ? ' вес' : ' объём')}`"
				v-model="price.value_min" name="value_min" id="value_min" class="col-6" data-vv-name="value_min"
				v-validate="{required: true, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
				v-bind:error="errors.first('value_min')" type="number" v-bind:data-vv-as="' '" required
			></z-input>

			<z-input
				:label="`Максимальный ${(parseInt(price.type) == 1 ? ' вес' : ' объём')}`"
				v-model="price.value_max" name="value_max" id="value_max" class="col-6" data-vv-name="value_max"
				v-validate="{required: true, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
				v-bind:error="errors.first('value_max')" type="number" v-bind:data-vv-as="' '" required
			></z-input>
		</div>

		<z-input
			v-model="price.min_time" label="Минимальное время (часы)" name="min_time" id="min_time" data-vv-name="min_time"
			v-validate="{required: true, integer: true, min_value: 0, max_value: 9999999999}"
			v-bind:error="errors.first('min_time')" type="number" v-bind:data-vv-as="' '" required
		></z-input>

		<z-input
			v-model="price.price" name="price" id="price"
			:label="`Цена за ${(parseInt(price.type) == 2 ? ' объём' : ' вес') + (price.is_min ? ' (за весь)' : ' (за единицу)')}`"
			v-validate="{required: true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" required
			v-bind:error="errors.first('price')" type="number" data-vv-name="price" v-bind:data-vv-as="' '"
		></z-input>
    </entity-page>
</template>
<script>
	import ZInput  from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
	import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	export default {
		components: { ZInputAutocomplete, ZInput, ZSelect, ZIconButton, EntityPage },
		data() {
			return {
				price: {},
				priceDefault: {
                    id: null,
					type: 1,
					is_min: 0,
					min_time: null,
					price: null,
					value_min: null,
					value_max: null,
				},
                types: {
                    1: {
                        name: 'По весу',
                        value: 1,
                    },
                    2: {
                        name: 'По объёму',
                        value: 2,
                    }                   
                }
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
			progress() {
				return this.progressObj['load-manipulator-card'];
			},
			/**
             * Объект с флагами загрузки
             */
			progressObj() {
				return this.$store.state.progressObj;
			}
		},
		watch: {
			'$route.params.id'() {
				this.init();
			}
		},
		methods: {
			/**
             * Инициализация компонента
             */
			init() {
				this.$store.commit('openRightPanel');
				if (this.$route.params.id !== 'new') this.getPrice();
				else this.price = Object.assign({}, this.priceDefault);
			},
			/**
			 * Получение ценгы
			 */
			getPrice() {
				this.$store.commit('showProgressBar', 'load-manipulator-card');
				return this.$store.dispatch('cost/getManipulatorPrice', this.$route.params.id).then(r => {
					this.price = Object.assign({}, r);
					return this.price;
				}).finally(() => this.$store.commit('hideProgressBar', 'load-manipulator-card'));
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					if (this.$route.params.id != 'new') this.putPrice();
                    else this.postPrice();
				});
			},
			/**
			 * Добавление цены
			 */
			postPrice() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-manipulator-card');
                    this.$store.dispatch('cost/postManipulatorPrice', this.price).then(r => {
                        this.$root.$emit('reload-table', 'manipulatorprice');
                        this.$router.replace({name: 'ManipulatorPrice', params: {id: r.id}});
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-manipulator-card'));
                });
			},
			/**
			 * Изменение цены
			 */
			putPrice() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-manipulator-card');
                    this.$store.dispatch('cost/putManipulatorPrice', this.price).then(r => {
                        if (!r) return;
                        this.init();
                        this.$root.$emit('reload-table', 'manipulatorprice');
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-manipulator-card'));
                });
			},
			/**
		 	* Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
			back() {
                this.$router.push({name: 'ManipulatorPrices', query: this.$route.query});
            }
		},
		created() {
			this.init();
		}		
	}
</script>


// WEBPACK FOOTER //
// Manipulator.vue?63a7a45d